<template>
  <div class="sedna-slider">
    <div
      class="slide"
      v-for="(item, i) in items"
      :key="i"
      :class="i === activeSlide ? `active` : `inactive`"
    >
      <div class="slideTitle">
        <h2>{{ item.title }}</h2>
        <div class="details" style="position: absolute; bottom:0; width:100%;">
          <div class="timestamp" style="position:absolute; bottom:0;">
            {{ item.timestamp }}
          </div>
          <div class="source" style="position: absolute; bottom:0; right:0">
            {{ item.sourceTitle }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Slider",
  props: {
    items: Array
  },
  data() {
    return {
      activeSlide: 0,
      timer: null
    };
  },
  methods: {
    randomizeSlide: function() {
      const maxNumber = this.items.length;
      this.activeSlide = Math.floor(Math.random() * Math.floor(maxNumber));
    }
  },
  mounted: function() {
    let timerDelay = 3;
    const urlQuery = new URLSearchParams(window.location.search);
    if (urlQuery.get("delay") !== null) {
      timerDelay = parseFloat(urlQuery.get("delay"));
    }

    this.randomizeSlide();
    this.timer = setInterval(this.randomizeSlide, timerDelay * 1000);
  },
  beforeDestroy: function() {
    clearInterval(this.timer);
  }
};
</script>

<style>
.sedna-slider {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.slide {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  opacity: 0;
  transition: opacity 0.6s ease-in-out;
}
.slide.active {
  opacity: 1;
  transition: opacity 0.6s ease-in-out;
}
.slideTitle {
  position: absolute;
  bottom: 0;
}
.slideTitle h2 {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}

@media screen and (max-width: 3839px) {
  .slide .details {
    height: 50px;
  }
  .details .timestamp,
  .details .source,
  .aretv .slide .source,
  .aretv .slide .timestamp {
    font-size: 32px;
    font-weight: 100;
  }
  .slideTitle {
    width: 1700px;
    height: 300px;
  }
}
@media screen and (min-width: 3840px) {
  .slide .details {
    height: 100px;
  }
  .details .timestamp,
  .details .source,
  .aretv .slide .source,
  .aretv .slide .timestamp {
    font-size: 64px;
    font-weight: 100;
  }
  .slideTitle {
    width: 3400px;
    height: 600px;
  }
}
</style>
